var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "21",
        viewBox: "0 0 18 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M10.2666 1.43408H11.2666L16.2666 6.34093C16.2666 6.49652 16.2666 6.66041 16.2666 6.83161M10.2666 1.43408H2.7666C2.2666 1.43409 1.2666 1.72848 1.2666 2.90613C1.2666 4.08378 1.2666 13.5376 1.2666 18.1173C1.2666 18.7716 1.6666 20.0801 3.2666 20.0801C4.8666 20.0801 10.9333 20.0801 14.2666 20.0801C14.9333 20.0801 16.2666 19.6875 16.2666 18.1173C16.2666 16.6218 16.2666 10.2597 16.2666 6.83161M10.2666 1.43408V5.85024C10.2666 6.17736 10.5666 6.83161 11.7666 6.83161C12.9666 6.83161 15.2666 6.83161 16.2666 6.83161",
          stroke: "white",
          "stroke-width": "1.5"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "4.10107",
          y: "11.7778",
          width: "2.02222",
          height: "5.6317",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "7.75537",
          y: "13.6934",
          width: "2.02222",
          height: "3.71639",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "11.4097",
          y: "8.94141",
          width: "2.02222",
          height: "8.4679",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }